import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="max-w-2xl w-full text-center">
        <div className="flex justify-center mb-6">
          <CheckCircle size={80} className="text-green-600" />
        </div>

        <h1 className="font-serif text-4xl md:text-5xl text-gray-900 mb-6">
          Thank You for Registering
        </h1>

        <p className="text-xl text-gray-700 mb-10 leading-relaxed">
          Thank you for registering for the Parent Orientation. You will receive session details on WhatsApp and Email shortly.
        </p>

        <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-6 mb-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">
            What Happens Next?
          </h2>
          <ul className="text-left text-gray-700 space-y-2">
            <li className="flex items-start">
              <span className="text-blue-900 mr-2">•</span>
              <span>You will receive a confirmation message on WhatsApp</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-900 mr-2">•</span>
              <span>An email with orientation details will be sent to your registered email address</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-900 mr-2">•</span>
              <span>Session access link will be shared 24 hours before the orientation</span>
            </li>
          </ul>
        </div>

        <Button
          onClick={() => navigate('/')}
          className="bg-blue-900 hover:bg-blue-800 text-white px-8 py-5 text-lg transition-colors"
        >
          Back to Home
        </Button>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-600">
            <strong>Questions?</strong> If you don't receive confirmation within 24 hours, please check your spam folder or contact us.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
